import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShareArrowDown"><Path d="M8.5 11.5L12 15L15.5 11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 14V1.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 4.5H20.5V20.5H3.5V4.5H7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShareArrowDown;
